import { useEffect, useState } from "react";
import { Flame, Trophy } from "lucide-react";
import { api } from "../lib/api";

export default function DriverStreak() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/driver-card/streak").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  const pct = s.next_tier ? Math.round((s.weeks / s.next_tier.weeks) * 100) : 100;
  return (
    <section className="rounded-2xl bg-[#131722] border border-slate-800 p-5 grid sm:grid-cols-[auto_1fr_auto] gap-4 items-center" data-testid="driver-streak">
      <div className={`w-14 h-14 rounded-2xl grid place-items-center ${s.weeks ? "bg-orange-500/15 text-orange-300" : "bg-slate-800 text-slate-500"}`}><Flame className="w-7 h-7" /></div>
      <div className="min-w-0">
        <p className="font-mono text-[10px] tracking-[0.25em] text-cyan-400">ON-TIME STREAK</p>
        <h3 className="font-display text-xl font-extrabold tracking-tight" data-testid="driver-streak-weeks">{s.weeks} week{s.weeks === 1 ? "" : "s"}{s.tier && <span className="ml-2 text-sm font-semibold text-amber-300 inline-flex items-center gap-1" data-testid="driver-streak-tier"><Trophy className="w-3.5 h-3.5" />{s.tier}</span>}</h3>
        <p className="text-xs text-slate-400 mt-0.5">This week: {s.this_week.on_time}/{s.this_week.deliveries} on time · {s.rules}</p>
        <div className="h-1.5 rounded-full bg-slate-800 mt-2 overflow-hidden"><div className="h-full bg-gradient-to-r from-orange-400 to-amber-300 transition-[width]" style={{ width: `${pct}%` }} /></div>
        {s.next_tier && <p className="text-[11px] text-slate-500 mt-1">{s.next_tier.to_go} more week{s.next_tier.to_go === 1 ? "" : "s"} to <span className="text-slate-300">{s.next_tier.name}</span></p>}
      </div>
      <div className="text-right">
        <p className="text-[10px] font-mono tracking-widest text-slate-500">WEEKLY BONUS</p>
        <p className="text-2xl font-extrabold text-emerald-300" data-testid="driver-streak-bonus">${s.weekly_bonus.toFixed(0)}</p>
        <p className="text-[11px] text-slate-500">${s.bonus_earned_total.toFixed(0)} earned total</p>
      </div>
    </section>
  );
}
